import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/auth/fire-auth/authentication.service';
import { ChatService } from '../../services/chat.service';
import { UserfirestoreService } from 'src/app/auth/fire-store/userfirestore.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { catchError, switchMap, takeUntil } from 'rxjs/operators';
import { EMPTY, Subject } from 'rxjs';
import { ChatDetailComponent } from '../chat-detail/chat-detail.component';

@Component({
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit, OnDestroy {
  @ViewChild(ChatDetailComponent, { static: false })
  private childComponent: ChatDetailComponent;
  private destroyed$ = new Subject();

  users$ = this.userService.users$.pipe(
    catchError((err) => {
      this.errorMessageSubject.next(err);
      return EMPTY;
    })
  );

  conversationID: string;
  dataReady: boolean = true;
  me: any;
  mobileQuery: MediaQueryList;
  myname: any;
  searchString: string = '';
  startConvesation: Boolean = true;
  subscription;
  textMessage: string;
  textsFromDB: any[];
  users;
  userSelected;

  private errorMessageSubject = new Subject<string>();
  errorMessage$ = this.errorMessageSubject.asObservable();

  private _mobileQueryListener: () => void;

  constructor(
    private activatedRoute: ActivatedRoute,
    private userService: UserfirestoreService,
    private chatService: ChatService,
    private authenticationService: AuthenticationService,
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher
  ) {
    // @mediaQueries
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {
    this.authenticationService
      .getStatus()
      .pipe(
        switchMap((status) =>
          this.userService.getUserById(status.uid).valueChanges()
        ),
        switchMap((user: any) => {
          this.me = user;
          return this.activatedRoute.params;
        }),
        switchMap((params) => {
          if (params.id !== 'start-conversation') {
            return this.userService.getUserById(params.id).valueChanges();
          } else {
            this.startConvesation = true;
            return EMPTY;
          }
        }),
        takeUntil(this.destroyed$)
      )
      .subscribe(
        (data) => {
          if (!data) this.startConvesation = true;
          else {
            this.generateChatId(data);
            this.getChatById();
            this.startConvesation = false;
          }
        },
        (err) => console.log(err) // TODO HANDLE ERROR
      );
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  generateChatId(data) {
    this.userSelected = data; // Receptor
    const myIDString = this.me.uid;
    const ids = [myIDString, this.userSelected.uid].sort();
    this.conversationID = ids.join('|');
  }

  getChatById() {
    this.chatService.getConversation(this.conversationID).subscribe(
      (data) => {
        console.log(data);
        this.textsFromDB = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  receiveMessageFromChild($event) {
    this.textMessage = $event;
    this.sendMessage();
  }

  sendMessage() {
    const message = {
      chatId: this.conversationID,
      timestamp: Date.now(),
      text: this.textMessage,
      sender: this.me.uid,
      receiver: this.userSelected.uid,
    };
    this.chatService.createConversation(message).then(() => {
      this.textMessage = '';
      this.childComponent.updateScroll();
    });
  }
}
